module.exports = __webpack_public_path__ + "media/alaska/top_forrest-422a6948.jpg";